// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import NavbarComponent from './components/NavbarComponent';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AdminLogin from './pages/AdminLogin';

// Create a wrapper component to conditionally render Footer
function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/admin-login';
  
  return (
    <div className="App d-flex flex-column min-vh-100">
      {/* Always show Navbar */}
      <NavbarComponent />
      
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
        </Routes>
      </main>
      
      {/* Hide Footer only on login page */}
      {!isLoginPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;